import React, { useState, useEffect } from 'react';
import { AuthProvider } from './contexts/AuthContext';
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import Facilities from './components/Facilities';
import WhatWeOffer from './components/WhatWeOffer';
import Footer from './components/Footer';
import TastyBites from './pages/TastyBites';
import CosyStays from './pages/CosyStays';
import WelcomingBar from './pages/WelcomingBar';
import PAwesomePets from './pages/PAwesomePets';
import PrivateEvents from './pages/PrivateEvents';
import LocalArea from './pages/LocalArea';
import OurStory from './pages/OurStory';
import Contact from './pages/Contact';
import ProtectedRoute from './components/ProtectedRoute';
import AdminDashboard from './admin/AdminDashboard';
import { DataProvider } from './contexts/DataContext';
import './App.css';

function App() {
  const [activeTab, setActiveTab] = useState('home');
  const [scrollTarget, setScrollTarget] = useState(null);
  const [isAdminMode, setIsAdminMode] = useState(false);

  // Check for admin URL on load
  useEffect(() => {
    const path = window.location.pathname;
    if (path === '/qh-admin' || path.startsWith('/qh-admin/')) {
      setIsAdminMode(true);
    }
  }, []);

  // Listen for URL changes
  useEffect(() => {
    const handlePopState = () => {
      const path = window.location.pathname;
      if (path === '/qh-admin' || path.startsWith('/qh-admin/')) {
        setIsAdminMode(true);
      } else {
        setIsAdminMode(false);
      }
    };

    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []);

  const handleNavigation = (tabId, scrollTo = null) => {
    // Map YouMayAlsoLike page IDs to actual tab IDs
    const pageMapping = {
      'cosy-stays': 'rooms',
      'welcoming-bar': 'welcoming-bar',
      'tasty-bites': 'menu',
      'pawsome-pets': 'pets',
      'private-events': 'private-events',
      'our-story': 'story', // Future page
      'local-area': 'area'
    };
    
    const mappedTabId = pageMapping[tabId] || tabId;
    setActiveTab(mappedTabId);
    setScrollTarget(scrollTo);
    
    // Only scroll to top if no specific scroll target
    if (!scrollTo) {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
    
    console.log(`Navigating to: ${tabId}${scrollTo ? ` (scroll to: ${scrollTo})` : ''}`);
  };

  // Admin mode routing
  if (isAdminMode) {
    return (
      <AuthProvider>
        <DataProvider>
          <ProtectedRoute>
            <AdminDashboard />
          </ProtectedRoute>
        </DataProvider>
      </AuthProvider>
    );
  }

  // Regular website routing
  return (
    <DataProvider>
      <div className="App">
        <Navigation activeTab={activeTab} onNavigate={handleNavigation} />
        <main>
          {activeTab === 'home' && (
            <>
              <Hero />
              <Facilities />
              <WhatWeOffer onNavigate={handleNavigation} />
            </>
          )}
          {activeTab === 'menu' && (
            <TastyBites onNavigate={handleNavigation} />
          )}
          {activeTab === 'rooms' && (
            <CosyStays onNavigate={handleNavigation} />
          )}
          {activeTab === 'welcoming-bar' && (
            <WelcomingBar activeTab={activeTab} scrollTarget={scrollTarget} onNavigate={handleNavigation} />
          )}
          {activeTab === 'private-events' && (
            <PrivateEvents onNavigate={handleNavigation} />
          )}
          {activeTab === 'contact' && (
            <Contact onNavigate={handleNavigation} />
          )}
          {activeTab === 'admin' && (
            <div className="page-content">
              <h1>Admin Page</h1>
              <p>Admin functionality will be implemented here.</p>
            </div>
          )}
          {activeTab === 'tasty-bites' && (
            <TastyBites onNavigate={handleNavigation} />
          )}
          {activeTab === 'pets' && (
            <PAwesomePets onNavigate={handleNavigation} />
          )}
          {activeTab === 'events' && (
            <PrivateEvents onNavigate={handleNavigation} />
          )}
          {activeTab === 'area' && (
            <LocalArea onNavigate={handleNavigation} />
          )}
          {activeTab === 'story' && (
            <OurStory onNavigate={handleNavigation} />
          )}
        </main>
        <Footer onNavigate={handleNavigation} />
      </div>
    </DataProvider>
  );
}

export default App;
